import { ColumnDef } from "@tanstack/react-table";
import { RvDto, rvFormData } from "../../types/rv";
import { FieldDefinition } from "../../types/fieldDefinitions";
import {
  GDPRNoConsentPatientDto,
  gdprFields,
  DocumentWithNoFileDto,
  documentFields,
} from "../../types/pendingTasks";

const createColumnsFromFields = <T,>(
  fields: FieldDefinition[],
): ColumnDef<T>[] => {
  return fields.map((field) => ({
    accessorKey: field.name as keyof T,
    header: field.label,
  }));
};

// Χωρίς το <RvDto> μέσα στο JSX context, το παίρνει αυτόματα από το ColumnDef<RvDto>[]
export const todaysRvColumns: ColumnDef<RvDto>[] =
  createColumnsFromFields(rvFormData);
export const recentRvColumns: ColumnDef<RvDto>[] =
  createColumnsFromFields(rvFormData);
export const newPatientsColumns: ColumnDef<RvDto>[] =
  createColumnsFromFields(rvFormData);
export const gdprColumns: ColumnDef<GDPRNoConsentPatientDto>[] =
  createColumnsFromFields(gdprFields);
export const documentColumns: ColumnDef<DocumentWithNoFileDto>[] =
  createColumnsFromFields(documentFields);
